export default {
  pages: {
    DESKTOP_SHEET: "/desktop/sheet",
    ASSET_SHEET: "/asset/sheet",
    /** Desarrollo: maquetación del informe con datos mock, sin API */
    ASSET_SHEET_DEV: "/asset/sheet-dev",
  },
  api: {
    indicators: {
      LIST: "indicators/v2/list",
    },
    comparables: {
      LIST: "comparables/v2/list",
    },
  },
};
